import { buttonHoverColor, primaryColor } from "../palette";
export const MuiIconButton = {
  MuiIconButton: {
    root: {
      "&:hover": {
        backgroundColor: buttonHoverColor,
      },
    },
  },
};
